import React, { memo } from "react";
import { Route, Router, Switch, Redirect } from "react-router";
import { AgentContainer } from "./containers/agentContainer";
import { FourOFour } from "./containers/404";
import { GraphqlClientSettingsPage } from "fe-web-components/settings/GraphqlSettingsPage";
import { useSession } from "fe-web-components/userSession/userSession";
import { useCreateHistory } from "fe-common/routes/createHistory";
import { ClinicContainer } from "./components/clinic/clinicContainer";
import {
  CLINIC_MANAGE_URL,
  EXTENSION_URL,
} from "./components/clinic/clinicSettings/clinicUrls";
import { useDiagnosticNavigation } from "./components/diagnosticAgent/useDiagnosticNavigation";
import { SendFeedbackDialog } from "./components/diagnosticAgent/common/SendFeedbackDialog";
import { ExtensionContainer } from "./components/extensionOnboarding/extensionContainer";
import { ThreeDotsLoader } from "fe-web-components/loader/threeDotsLoader";
import { useSocialRedirect } from "@kahunmedical/user-management";

export const KahunRouter = memo(() => {
  const {
    feedbackDialogProps,
    setFeedbackDialogProps,
  } = useDiagnosticNavigation();
  const { session } = useSession();
  const history = useCreateHistory();
  const { loading } = useSocialRedirect(history);

  if (loading) return <ThreeDotsLoader />;

  return (
    <>
      {session?.showSessionInfo && (
        <pre
          style={{
            zIndex: 2000,
            position: "absolute",
            background: "aliceblue",
          }}
        >
          <code>{JSON.stringify(session, null, 4)}</code>
        </pre>
      )}
      {!session?.isSessionValid && <Redirect to="/login" />}

      <Router history={history}>
        <Switch>
          <Route path={"/"} exact component={AgentContainer} />
          <Route path={"/login"} exact component={AgentContainer} />
          <Route path={"/signup"} exact component={AgentContainer} />
          <Route path={"/newPassword"} exact component={AgentContainer} />
          <Route path={"/agent"} component={AgentContainer} />
          <Route path={CLINIC_MANAGE_URL} component={ClinicContainer} />
          <Route path={EXTENSION_URL} component={ExtensionContainer} />
          <Route path={"/clinic"} component={AgentContainer} />
          <Route path={"/clinic/agent"} component={AgentContainer} />
          <Route path="/settings" exact component={GraphqlClientSettingsPage} />
          <Route component={FourOFour} />
        </Switch>
        {feedbackDialogProps?.open && (
          <SendFeedbackDialog
            isOpen={true}
            withCaseId={feedbackDialogProps.caseId}
            clinicName={feedbackDialogProps.clinicName}
            onClose={() =>
              setFeedbackDialogProps({ open: false, caseId: null })
            }
          />
        )}
      </Router>
    </>
  );
});
